export function generateDashboardFilters(filters) {
  const dashboardFilters = {};

  if (filters.status?.length) dashboardFilters.status = filters.status;
  if (filters.location?.length) dashboardFilters.location = filters.location;
  if (filters.customer?.length) dashboardFilters.customer = filters.customer;
  if (filters.search) dashboardFilters.renter = filters.search;
  if (filters.unitNumber) dashboardFilters.unit_number = filters.unitNumber;
  if (filters.overdue) dashboardFilters.overdue = filters.overdue;
  if (filters.next) dashboardFilters.next = filters.next;
  if (filters.previous) dashboardFilters.previous = filters.previous;
  if (filters.aging?.length) dashboardFilters.aging = filters.aging;

  if (filters.auctionFrom && filters.auctionTo) {
    dashboardFilters.auction = {
      min: filters.auctionFrom,
      max: filters.auctionTo
    };
  } else if (filters.auctionTo) {
    dashboardFilters.auction = {
      max: filters.auctionTo
    };
  } else if (filters.auctionFrom) {
    dashboardFilters.auction = {
      min: filters.auctionFrom
    };
  }

  if (filters.dueAmountMin && filters.dueAmountMax) {
    dashboardFilters.due_amount = {
      min: filters.dueAmountMin,
      max: filters.dueAmountMax
    };
  } else if (filters.dueAmountMax) {
    dashboardFilters.due_amount = {
      max: filters.dueAmountMax
    };
  } else if (filters.dueAmountMin) {
    dashboardFilters.due_amount = {
      min: filters.dueAmountMin
    };
  }
  if (filters.pastDueMin && filters.pastDueMax) {
    dashboardFilters.delay = {
      min: filters.pastDueMin,
      max: filters.pastDueMax
    };
  } else if (filters.pastDueMax) {
    dashboardFilters.delay = {
      max: filters.pastDueMax
    };
  } else if (filters.pastDueMin) {
    dashboardFilters.delay = {
      min: filters.pastDueMin
    };
  }

  return dashboardFilters;
}

// export function generateDashboardFilters(domen, uuid, filters) {
//   let url = `${domen}view/all_liens/${uuid}`;
//   const {
//     status,
//     location,
//     customer,
//     search,
//     unitNumber,
//     overdue,
//     next,
//     previous,
//     aging,
//     auctionFrom,
//     auctionTo,
//     dueAmountMax,
//     dueAmountMin,
//   } = filters;

//   if (status?.length) {
//     if (url.includes("filters")) {
//       status.forEach((el) => {
//         url += `&filters[status][]=${el}`;
//       });
//     } else {
//       const [, ...rest] = status;
//       url += `?filters[status][]=${status[0]}`;
//       rest?.forEach((el) => {
//         url += `&filters[status][]=${el}`;
//       });
//     }
//   }
//   if (location?.length) {
//     if (url.includes("filters")) {
//       location.forEach((el) => {
//         url += `&filters[location][]=${el}`;
//       });
//     } else {
//       const [, ...rest] = location;
//       url += `?filters[location][]=${location[0]}`;
//       rest?.forEach((el) => {
//         url += `&filters[location][]=${el}`;
//       });
//     }
//   }
//   if (customer?.length) {
//     if (url.includes("filters")) {
//       customer.forEach((el) => {
//         url += `&filters[customer][]=${el}`;
//       });
//     } else {
//       const [, ...rest] = customer;
//       url += `?filters[customer][]=${customer[0]}`;
//       rest?.forEach((el) => {
//         url += `&filters[customer][]=${el}`;
//       });
//     }
//   }
//   if (aging?.length) {
//     if (url.includes("filters")) {
//       aging.forEach((el) => {
//         url += `&filters[aging][]=${el}`;
//       });
//     } else {
//       const [, ...rest] = aging;
//       url += `?filters[aging][]=${aging[0]}`;
//       rest?.forEach((el) => {
//         url += `&filters[aging][]=${el}`;
//       });
//     }
//   }
//   if (auctionTo) {
//     url += url.includes("filters")
//       ? `&filters[auction][max]=${auctionTo}`
//       : `?filters[auction][max]=${auctionTo}`;
//   }
//   if (auctionFrom) {
//     url += url.includes("filters")
//       ? `&filters[auction][min]=${auctionFrom}`
//       : `?filters[auction][min]=${auctionFrom}`;
//   }
//   if (dueAmountMin) {
//     url += url.includes("filters")
//       ? `&filters[due_amount][min]=${dueAmountMin}`
//       : `?filters[due_amount][min]=${dueAmountMin}`;
//   }
//   if (dueAmountMax) {
//     url += url.includes("filters")
//       ? `&filters[due_amount][max]=${dueAmountMax}`
//       : `?filters[due_amount][max]=${dueAmountMax}`;
//   }
//   if (unitNumber) {
//     url += url.includes("filters")
//       ? `&filters[unit_number]=${unitNumber}`
//       : `?filters[unit_number]=${unitNumber}`;
//   }
//   if (next) {
//     url += url.includes("filters")
//       ? `&filters[next]=${next}`
//       : `?filters[next]=${next}`;
//   }
//   if (previous) {
//     url += url.includes("filters")
//       ? `&filters[previous]=${previous}`
//       : `?filters[previous]=${previous}`;
//   }
//   if (overdue) {
//     url += url.includes("filters")
//       ? `&filters[overdue]=${overdue}`
//       : `?filters[overdue]=${overdue}`;
//   }
//   if (search) {
//     url += url.includes("filters")
//       ? `&filters[renter]=${search}`
//       : `?filters[renter]=${search}`;
//   }
//   return url;
// }

export default null;
